import { isDevEnvironment } from "../utils/envUtils.ts";

const use_dev_prefix: boolean = isDevEnvironment();

const base_url: string = `https://api.${use_dev_prefix ? "dev." : ""}lettari.me`;

export const ServiceURL = {
    EMAILS: {
        BASE: `${base_url}/emails`,
    },
};
